<template>
    <section id="wrapper" class="wrapper view-thankyou" :class="theme">
        <div class="progress">
            <div class="w-3/3 progress-bar">
                <div class="progress-value">3/3</div>
            </div>
        </div>

        <section class="clearfix py-10 content section--whitespace">
            <div class="text-center">
                <div class="px-4">
                <h1 class="w-full mx-auto md:w-1/2 mb-4 text-2xl font-semibold">Tack för din order!</h1>
                    <p class="w-full mx-auto md:w-1/2">
                        Vi har nu mottagit din order enligt nedan. En bekräftelse kommer att skickas till din e-postadress så snart vi har bearbetat din order.
                    </p>
                    
                    <div class="w-full mx-auto md:w-1/2 flex">
                        <ul class="mx-auto mt-8">
                            <article class="productEntity" v-for="item in placedOrderData" :key="item.id">
                                <div class="product-image">
                                    <img class="object-cover object-center w-full h-full" :src="item.image_url ?? '/img/no-image.jpg'" :alt="item.name"/>
                                </div>
                                <h3 class="title">{{ item.name }}</h3>
                                <div class="actions">{{ item.quantity }} st</div>
                            </article>
                        </ul>
                    </div>

                    <div class="flex items-center justify-center mt-8">
                        <a href="" @click.prevent="$emit('setActiveView', 'products')" class="btn-primary">Skapa en ny order</a>
                    </div>
                </div>
            </div>
        </section>

        <section class="clearfix py-10 content section--whitespace newsletter-section">
            <div
                v-if="t_bg && t_text"
                class="flex flex-col justify-center items-center min-h-[400px] text-[#fff] text-center"
                :style="{ 'background-image': `url(${ t_bg })` }"
            >
                <div class="t-content mb-[30px]" v-html="t_text"></div>
                <a
                    v-if="t_cta_link && t_cta_txt"
                    class="btn-indigo"
                    href=""
                    @click.prevent="gotoNewsletterForm(t_cta_link)"
                >
                    {{ t_cta_txt }}
                </a>
            </div>

            <div
                v-if="t_iframe"
                class="iframe mt-[30px]"
                v-html="t_iframe"
            >
            </div>
        </section>
    </section>
</template>

<script>
    import { onMounted, toRefs, reactive, ref } from 'vue'

    export default {
        name: 'Checkout',
        props: {
            categories: {
                type: [Array, Object],
                required: false,
            },
            parentCategory: {
                type: Object,
                required: true,
            },
            childCategory: {
                type: Object,
                required: false,
            },
            placedOrderData: {
                type: Object,
                required: true,
            },
        },
        setup(props, { emit }) {

            const data = reactive({
                t_bg: props.parentCategory.background_image_url,
                t_text: props.parentCategory.t_text,
                t_cta_txt: props.parentCategory.t_cta_txt,
                t_cta_link: props.parentCategory.t_cta_link,
                t_iframe: props.parentCategory.t_iframe,
                t_bg_name: props.parentCategory.t_bg_name
            })

            const theme = props.parentCategory.color_scheme

            onMounted(() => {
                window.scrollTo(0,0)
            })

            const gotoNewsletterForm = (t_cta_link) => {

                if (t_cta_link.indexOf('#') > -1) {
                    t_cta_link = t_cta_link.replace('#', '')
                }

                document.getElementById(t_cta_link).scrollIntoView();
            }

            emit('cartUpdated', []);
            emit('setSharableCartId', null);

            return {
                theme,
                ...toRefs(data),
                gotoNewsletterForm
            }
        }
    }
</script>

<style>
    .t-content {
        font-size: 20px;
        line-height: 20px;
    }

    .t-content h1,
    .t-content h2
    .t-content h3 {
        display: block;
        margin-bottom: 30px;
        color: #fff;
        font-size: 1.5rem;
        line-height: 2rem;
    }

    .iframe iframe {
        width: 100%;
        height: 100vh;
        display: block;
    }
</style>
